import { render, staticRenderFns } from "./rmHpbk.vue?vue&type=template&id=048dc7ca"
import script from "./rmHpbk.vue?vue&type=script&lang=js"
export * from "./rmHpbk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports